import {Grid} from "@mui/material";
import * as React from "react";
import {FormTextField} from "../../common/form-fields";
import {useTranslation} from "react-i18next";
import {useFormContext} from "react-hook-form";
import {FormOWLocationGroupModel} from "../../api/types/owLocationGroup";
import DealerAndTenant from "../../common/components/DealerAndTenant";

const FormOWLocationGroup = ({readOnly}: { readOnly: boolean }) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Form Context
    const {register} = useFormContext<FormOWLocationGroupModel>();

    return (
        <Grid container spacing={2} alignItems="start">
            {/* NAME */}
            <Grid item xs={12} md={3}>
                <FormTextField
                    {...register("name")}
                    label={`${t("pricing:rentalPeriods.form.labels.name")}*`}
                />
            </Grid>
            <DealerAndTenant
                readOnly={readOnly}
                md={3}
                legalEntityName={"legalEntities"}
                dealerName={"dealers"}
            />
        </Grid>
    );
};

export default FormOWLocationGroup;